import { render, staticRenderFns } from "./RegosParts.vue?vue&type=template&id=6d306514&scoped=true&"
import script from "./RegosParts.vue?vue&type=script&lang=js&"
export * from "./RegosParts.vue?vue&type=script&lang=js&"
import style0 from "./RegosParts.vue?vue&type=style&index=0&id=6d306514&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d306514",
  null
  
)

export default component.exports